import React from 'react';
import { Badge, Group, createStyles } from '@mantine/core';

import useUserData from '../store/useUserStore';

function EmergencyTypeBadge({ size = 'lg', variant = 'filled', ...otherProps }) {
  const { classes } = useStyles();

  const { getUserSessions } = useUserData();
  const sessionData = getUserSessions().sessionData;

  const emergenciesEvents = sessionData?.emergenciesEvents;

  if (!Array.isArray(emergenciesEvents) || emergenciesEvents.length === 0) {
    return null;
  }

  return (
    <Group spacing={8} className={classes.container} {...otherProps}>
      {emergenciesEvents.map((emergency, index) => (
        <Badge
          key={`${emergency}-${index}`}
          size={size}
          variant={variant}
          color="red"
          radius="xl"
          className={classes.badge}
        >
          {emergency}
        </Badge>
      ))}
    </Group>
  );
}

export default EmergencyTypeBadge;

const useStyles = createStyles({
  container: {
    flexWrap: 'wrap',
  },
  badge: {
    textTransform: 'uppercase',
    fontWeight: 700,
    letterSpacing: 0.5,
  },
});
